import en from "./en.json";
import it from "./it.json";

const redeem = { en, it };

export default redeem;
